import {UPDATE_QUESTIONS_POLICY, CLEAR_NEW_LIABILITY_POLICY} from '../actions/types';

export const questionsPolicyReducer = (state = {ownerAddress: {}} , action) => {
    switch(action.type) {
        case UPDATE_QUESTIONS_POLICY:
            return {...state, ...action.payload} || false;
        case CLEAR_NEW_LIABILITY_POLICY:
            return {ownerAddress: {}};
            
        default:
            return state;
    }
}